import { Box } from '@material-ui/core';
import { getSignatureUrlsByLoanIdWithParams, SignatureUrls } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { NextActionSignContractProps } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/NextActionSignContract';
import { SamlSignature } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/SamlSignature/SamlSignature';
import { SignatureMissingVehicleDataCaption } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/SignatureMissingVehicleDataCaption';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { useErrorBoundary } from '@/components/shared/components/ErrorBoundary/hooks/useErrorBoundary';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const BbvaSamlSignature = ({ paymentMethodDetailEntity }: NextActionSignContractProps) => {
  const { getTextIdTranslation } = useTranslation();
  const { width, ref } = useWidth<HTMLDivElement>();
  const { throwErrorInDialog } = useErrorBoundary();

  const [signatureUrls, setSignatureUrls] = useState<SignatureUrls | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  const loan = paymentMethodDetailEntity.loan!;

  const disableSignContractButton = paymentMethodDetailEntity.isMissingVehicleRegistrationNumberOrLicensePlate();

  if (!loan.loanApplicationSelected) {
    return null;
  }

  const handleClick = async () => {
    setLoading(true);

    try {
      const signatureUrls = await getSignatureUrlsByLoanIdWithParams({
        loanId: loan.id,
        withUrls: true,
      });
      setLoading(false);

      setSignatureUrls(signatureUrls);
    } catch (error) {
      throwErrorInDialog(error);
    }
  };

  return (
    <CustomPaper fill="grey.light">
      <div
        ref={ref}
        style={{ display: 'flex', width: '100%', gridGap: 24, flexDirection: width && width > 600 ? 'row' : 'column' }}
      >
        <FlexColumn gridGap={4} flexGrow={1}>
          <Font variant="body2" color="textPrimary" display="block">
            <Text
              strong
              tId={'SIGNATURE_LENDER_CONTRACT'}
              dynamicDataTexts={[getTextIdTranslation(loan.loanApplicationSelected.lenderName)]}
            />
          </Font>
          <Font variant="body2" color="textSecondary" display="block">
            <Text tId={'SAML_SIGNATURE'} />
          </Font>
        </FlexColumn>
        <Box flexShrink={0}>
          {signatureUrls && (
            <SamlSignature
              signatureUrls={signatureUrls}
              paymentMethodDetailEntity={paymentMethodDetailEntity}
              openDialogOnRender
              disabled={disableSignContractButton}
            />
          )}
          {!signatureUrls && (
            <StandardButton
              main
              size="small"
              disabled={disableSignContractButton}
              onClick={() => handleClick()}
              loading={loading}
            >
              <Text tId={'SIGN_CONTRACT'} />
            </StandardButton>
          )}
        </Box>
      </div>
      <SignatureMissingVehicleDataCaption paymentMethodDetailEntity={paymentMethodDetailEntity} />
    </CustomPaper>
  );
};
